import { FunctionComponent } from 'react';

const CardBody: FunctionComponent = ({ children }) => {
  return <p className="fs-18 lh-30 fw-300">{children}</p>;
};

export default CardBody;
